import { jsx } from "react/jsx-runtime";
import React from "react";
import { useQuery } from "@betterment/js-runtime";
const FooterContext = React.createContext({ data: null, loading: false });
const FooterProvider = ({ children }) => {
  const { data, loading } = useQuery("/api/v2/disclosures");
  const values = React.useMemo(() => ({ data, loading }), [data, loading]);
  return /* @__PURE__ */ jsx(FooterContext.Provider, { value: values, children });
};
const useFooter = () => React.useContext(FooterContext);
export {
  FooterProvider as F,
  useFooter as u
};
//# sourceMappingURL=FooterProvider-CjpEJF0L.js.map
